import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../RushShell/icons';

const IntegrationsCard = ({ items = [] }) => {
    const active = items.filter((i) => i.connected).length;
    return (
        <div className="rs-card col-5">
            <div className="rs-card-h">
                <h3>Integrations</h3>
                <span className="count">{active} of {items.length} active</span>
                <div className="spacer" />
                <Link className="link" to="/dashboard/apps">
                    Manage {Icon.arrow}
                </Link>
            </div>
            <div className="intg-grid">
                {items.map((it) => (
                    <div className="intg" key={it.key}>
                        <span className={`ic ${it.cls || ''}`}>{it.letter}</span>
                        <div className="body">
                            <b>{it.name}</b>
                            <span className={it.connected ? 'on' : 'off'}>{it.status}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IntegrationsCard;
